namespace GeniuzPOS.PosShift {
    export interface PsPosMoneyCountForm {
        CountId: Serenity.IntegerEditor;
        CashierId: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        CountDate: Serenity.DateEditor;
        InTime: Serenity.StringEditor;
        CountType: Serenity.IntegerEditor;
        TypeCb: Serenity.IntegerEditor;
        TenderType: Serenity.IntegerEditor;
        TenderCode: Serenity.StringEditor;
        TenderName: Serenity.StringEditor;
        TenderRate: Serenity.DecimalEditor;
        TenderQty: Serenity.IntegerEditor;
        TenderAmt: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        BagCode: Serenity.StringEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
        CusWsFlg: Serenity.IntegerEditor;
    }

    export class PsPosMoneyCountForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsPosMoneyCount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosMoneyCountForm.init)  {
                PsPosMoneyCountForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(PsPosMoneyCountForm, [
                    'CountId', w0,
                    'CashierId', w1,
                    'PosId', w1,
                    'ShopId', w1,
                    'CountDate', w2,
                    'InTime', w1,
                    'CountType', w0,
                    'TypeCb', w0,
                    'TenderType', w0,
                    'TenderCode', w1,
                    'TenderName', w1,
                    'TenderRate', w3,
                    'TenderQty', w0,
                    'TenderAmt', w3,
                    'Remark', w1,
                    'BagCode', w1,
                    'CreateBy', w1,
                    'CreateDate', w2,
                    'UpdateBy', w1,
                    'LastUpdate', w2,
                    'CusWsFlg', w0
                ]);
            }
        }
    }
}
